"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M17.804 5.478a.75.75 0 0 1 .75.75v5.833a.75.75 0 0 1-.22.53L12.5 18.425c-.703.703-1.498.89-2.208.773a2.844 2.844 0 0 1-1.504-.773l-3.182-3.182c-.703-.703-.889-1.499-.773-2.209a2.843 2.843 0 0 1 .773-1.503l5.834-5.834a.75.75 0 0 1 .53-.22h5.834Zm-5.523 1.5-5.614 5.614a1.347 1.347 0 0 0-.354.683c-.039.24-.004.55.354.907l3.182 3.182c.136.136.397.307.684.354.24.04.55.004.907-.354l5.614-5.614V6.979H12.28Zm1.208 2.367a1.455 1.455 0 1 0 2.909 0 1.455 1.455 0 0 0-2.91 0Zm1.94 0a.485.485 0 1 0-.97 0 .485.485 0 0 0 .97 0Z",
    clipRule: "evenodd"
  })]
});